const getByPath = (obj, path, defaultValue) => {
  const result = path.split('.').reduce(
    (acc, key) => (acc != null ? acc[key] : undefined),
    obj
  );
  return result === undefined ? defaultValue : result;
};

export default getByPath;
